import { Typography } from "@mui/material";

export const TeacherRoomInfo = () => {
  return <></>;
};
